import AOS from "aos";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const siteNavigation = document.getElementById("site-navigation");
const burger = document.getElementById("burger");
const closeMenuBtn = document.getElementById("closeMenuBtn");
const page = document.getElementById("page");
//const homeLink = document.getElementById('homeLink');
import { Fancybox } from "@fancyapps/ui";

gsap.registerPlugin(ScrollTrigger);

function fadeInElements() {
  //////
  // get all the paragraphs on the page
  const elements = document.querySelectorAll(
    "cite, p, img, h2, h1, figcaption, .spotify-link, .bg-image, .video-wrapper"
  );

  // configure the intersection observer
  const observerOptions = {
    rootMargin: "0px",
    threshold: 0.5,
  };
  // create a new intersection observer instance
  const observer = new IntersectionObserver((entries) => {
    // loop through the observer entries
    entries.forEach((entry) => {
      // if the paragraph is intersecting the viewport
      if (entry.isIntersecting) {
        // add a "fade-in" class to the paragraph
        entry.target.classList.add("fade-in");

        // stop observing the paragraph (to prevent adding the class repeatedly)
        //  observer.unobserve(entry.target);
      } else {
        /*  entry.target.classList.remove('fade-in');*/
      }
    });
  }, observerOptions);

  // observe each paragraph element
  elements.forEach((element) => observer.observe(element));
}

window.addEventListener("load", function () {
  if (document.querySelector(".site-main header")) {
    const siteMainHeader = document.querySelector(".site-main header");
    siteMainHeader.classList.add("fade-in");
  }

  if (document.querySelector(".cloudflareBtn")) {
    var cloudflareBtns = document.querySelectorAll(".cloudflareBtn");
    cloudflareBtns.forEach(function (cloudflareBtn) {
      cloudflareBtn.addEventListener("click", function () {
        var target = cloudflareBtn.getAttribute("data-target");

        Fancybox.show([
          {
            src: target,
            type: "inline",
          },
        ]);

        const playerIframe = document.querySelector(target);
        const player = Stream(playerIframe.querySelector(".stream-player"));
        player.addEventListener("play", () => {
          console.log("playing!");
        });
        player.play().catch(() => {
          console.log("playback failed, muting to try again");
          player.muted = true;
          player.play();
        });
      });
    });
  }
  if (document.body.classList.contains("page-template-page-home")) {
    console.log("home page!");
    gsap
      .timeline()
      .to("#mainPhotoWrapper", { duration: 2, opacity: 1 })
      .to("#heroTextWrapper", { duration: 1, opacity: 1 })
      .to("#bookingEnquiries", { duration: 2, opacity: 1 })
      .to("#quoteWrapper", { duration: 2, delay: 0.5, opacity: 1 });
  }
  fadeInElements();
  /////////
  /////////
  var closeMenu = document.getElementsByClassName("closeMenu");
  for (var i = 0; i < closeMenu.length; i++) {
    closeMenu[i].addEventListener("click", fnCloseMenu);
  }

  var openMenu = document.getElementsByClassName("openMenu");
  for (var i = 0; i < openMenu.length; i++) {
    openMenu[i].addEventListener("click", fnOpenMenu);
  }

  var homeLink = document.getElementsByClassName("homeLink");
  for (var i = 0; i < homeLink.length; i++) {
    homeLink[i].addEventListener("click", fnHome);
  }

  var catItem = document.getElementsByClassName("catItem");
  var menuItem = document.getElementsByClassName("menuItem");

  for (var i = 0; i < catItem.length; i++) {
    catItem[i].addEventListener("mouseover", function (e) {
      // get the list of classes
      var myClasses = this.classList;
      for (var i = 0; i < catItem.length; i++) {
        catItem[i].classList.remove("text-black");
      }

      for (var x = 0; x < myClasses.length; x++) {
        // loop through the list of classes and check to see if class starts with 'cat-'
        if (myClasses[x].startsWith("cat-")) {
          var targetClass = myClasses[x];
          //return class name that starts with 'cat-' and target that class
          console.log(targetClass);
          var highlightItem = document.getElementsByClassName(targetClass);
          for (var i = 0; i < highlightItem.length; i++) {
            var myhighlightItem = highlightItem[i];
            myhighlightItem.classList.add("text-black");
          }
        } else {
          // this.classList.remove('bg-black');
        }
      }

      e.stopPropagation();
    });
  }

  for (var i = 0; i < menuItem.length; i++) {
    menuItem[i].addEventListener("click", function (e) {
      document.body.classList.remove("home");
      fnCloseMenu();
      var myClasses = this.classList;

      for (var x = 0; x < myClasses.length; x++) {
        if (myClasses[x].startsWith("id-")) {
          var targetClass = myClasses[x];
          var myID = targetClass.slice(3);
        }
      }

      ajaxLoadPost(myID);
    });
  }

  /*AOS.init({
        duration: 1200,
    });*/
});

function fnCloseMenu() {
  siteNavigation.classList.add("opacity-0", "pointer-events-none");
  burger.classList.remove("hidden");
  closeMenuBtn.classList.add("hidden");
  document.body.classList.remove("overflow-hidden");
  document.body.classList.remove("menu-open");
}

function fnOpenMenu() {
  siteNavigation.classList.remove("opacity-0", "pointer-events-none");
  burger.classList.add("hidden");
  closeMenuBtn.classList.remove("hidden");
  document.body.classList.add("overflow-hidden");
  document.body.classList.add("menu-open");
}

function fnHome() {
  var myID = 11;
  ajaxLoadPost(myID, false);
  var homePage = document.getElementsByClassName("home");
  if (homePage.length) {
    // do nothing
  } else {
    document.body.classList.add("home");
  }
}

window.onpopstate = function (event) {
  //  alert("location: " + document.location + ", state: " + JSON.stringify(event.state.page_id));
  // based on the event.state values, restore buttons visibility here...

  //  ajaxLoadPost(event.state.page_id);
  createHTML(event.state.postsData);
};

// get the actual height of the viewport to avoid scrolling
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);
window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

window.addEventListener("load", function () {
  const mailchimpPopUp = document.querySelector("#mailchimpPopUp");
  const closeModal = document.querySelector(".close-modal");
  const body = document.querySelector("body");

  if (!mailchimpPopUp || !closeModal) {
    console.log("Mailchimp modal elements not found");
    return;
  }

  function toggleModal() {
    body.classList.toggle("modal-active");
    mailchimpPopUp.classList.toggle("hidden");
  }

  var openmodal = document.querySelectorAll(".openModalBtn");
  for (var i = 0; i < openmodal.length; i++) {
    openmodal[i].addEventListener("click", function (event) {
      event.preventDefault();
      toggleModal();
    });
  }

  closeModal.addEventListener("click", function (event) {
    event.preventDefault();
    toggleModal();
  });
});
